/*==============================================================================
  
THEME.JS

Code that requires attention or edits is prefaced with `#CHANGE`

  #SLATE

  Slate A11y Helpers - slate.a11y
  Slate Utility Helpers - slate.utils
  Slate Rich Text Editor - slate.rte
  Theme Sections - theme.Sections
  Slate Currency - slate.Currency
  Slate Image - slate.Image
  Slate Variants - slate.Variants


  #CONFIG & UTILITIES

  theme.config (isTouch)
  theme.mq (breakpoints)
  theme.setBreakpoints (set breakpoint variables)
  theme.CartUtilities (AJAX Shopify API Utilities)
  theme.AjaxProduct (Ajax Add Product Functionality)
  theme.loadImageSection (Allows for adding classes whilst loading so we can animate)


  #MODULES
  
  theme.CustomSelect - custom select functionality
  theme.CustomSwitcher - custom dropdown functionality
  theme.RegionSelect - region selector functionality to change websites
  theme.HeaderNav - Header dropdown functionality
  theme.Modals - Sitewide modals functionality
  theme.Drawers - Drawers functionality
  theme.DrawerSearch - UNUSED DrawerSearch functionality for mobile focus of search input
  theme.Collapsibles - Sitewide Collapsibles functionality
  theme.Tabs - Sitewide Tabs functionality
  theme.ajaxNewsletterForm - Mailchimp AJAX signup integration



  #SECTIONS

  theme.HeaderSection
  theme.DrawerMenuSection
  theme.PopupSection
  theme.CookiesSection

  theme.Cart
  theme.Product
  theme.CollectionSection
  theme.SearchSection
  theme.LookbooksSection
  theme.PressSection
  theme.StockistsSection


  #TEMPLATES

  theme.customerAddresses
  theme.customerLogin


  #INIT

  theme.init (Tab Handling, Init modules)


  #DOC READY

  theme.init()
  sections.register
  a11y page link focus
  slate rte tables
  slate rte iframes

==============================================================================*/





window.slate = window.slate || {};
window.theme = window.theme || {};





/*==============================================================================
  #SLATE a11y
==============================================================================*/

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }

};










/*==============================================================================
  #SLATE Utility Helpers
==============================================================================*/

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 *
 * #EDIT
 * - Added arrayIncludes and uniq utilities for linked product options
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },


  /**
   * A utility from Shopify option_selection.js needed for linked product
   * options.
   */
  arrayIncludes: function(e, t) {
    for (var n = 0; n < e.length; n++)
        if (e[n] == t) return !0;
    return !1
  }, 


  /**
   * A utility from Shopify option_selection.js needed for linked product
   * options.
   */
  uniq: function(e) {
      for (var t = [], n = 0; n < e.length; n++) slate.utils.arrayIncludes(t, e[n]) || t.push(e[n]);
      return t
  }
};










/*==============================================================================
  #SLATE Rich Text Editor
==============================================================================*/

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};










/*==============================================================================
  #THEME Sections
==============================================================================*/

/**
 * Sections
 * - Largely based on Slate and Impulse theme with some minor adjustments.
 * - https://help.shopify.com/en/themes/development/sections#understand-the-interaction-between-theme-javascript-and-the-theme-editor
 * - Added support for subsections
 * - Added simpler findInstance and removeInstance functions
 */


theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  // Register event listeners for section events
  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {

  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  // We are using subSections for dynamic non-homepage section blocks
  _onSectionLoad: function(evt, subSection, subSectionId) {

    // Check if we have a subSection or a Section
    var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];

    // If no subSection or Section exists, stop running
    if (!container) {
      return;
    }

    // Register section
    this._createInstance(container);

    // Store subSection or Section ID as an instance
    var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

    // #? I don't understand this. Why is it loading subsections, if a
    // subsection doesn't exist?
    if (!subSection) {
      this._loadSubSections();
    }

    // Run JS only in case of the section being selected in the editor
    // before merchant clicks "Add"
    if (instance && typeof instance.onLoad === 'function') {
      instance.onLoad(evt);
    }
  },

  // Look for `data-subsection` attributes and load them
  _loadSubSections: function() {
    $('[data-subsection]').each(function(evt, el) {
      this._onSectionLoad(null, el, $(el).data('section-id'));
    }.bind(this));
  },

  _onSectionUnload: function(evt) {
    var instance = this._removeInstance(evt.detail.sectionId);

    if (instance && typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }
  },

  _onSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  // A simpler version of findInstance specific to sections
  _findInstance: function(id) {
    for (var i = 0; i < this.instances.length; i++) {
      if (this.instances[i].id === id) {
        return this.instances[i];
      }
    }
  },

  // A simpler version of removeInstance specific to sections
  _removeInstance: function(id) {
    var i = this.instances.length;
    var instance;

    while(i--) {
      if (this.instances[i].id === id) {
        instance = this.instances[i];
        this.instances.splice(i, 1);
        break;
      }
    }

    return instance;
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;
    var $sections = $('[data-section-type=' + type + ']');

    $sections.each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});










/*==============================================================================
  #SLATE Currency
==============================================================================*/

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();










/*==============================================================================
  #SLATE Image
==============================================================================*/

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 * #EDIT: Added default size of 620x to imageSize function
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   *
   * Added default size of 620x
   */
  function imageSize(src) {
    if (!src) {
      return '620x'; // default based on theme
    }

    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();










/*==============================================================================
  #SLATE Variants
==============================================================================*/

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 *
 * #EDIT: 
 * - Added _updateSKU function
 * - Added _updateVariantButtons function for linked options
 * - Updated _getVariantFromOptions code to be simpler
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.swatchSelector = options.swatchSelector;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));

    $(document).on('change', this.swatchSelector, function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
      if($(".size-text").length > 0) {
        $(".size-msg").addClass("hide");
      }
    jQuery(this)
      .closest('form')
      .find(options.singleOptionSelector)
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
   });

   $(this.singleOptionSelector, this.$container).on(
     'load',
     this._swatchOption(this.currentVariant)
   );
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var match = true;
        var options = variant.options

        selectedValues.forEach(function(option) {
          if (match) {
            match = (variant[option.index] === option.value);
          }
        });

        if (match) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this._updateVariantButtons(variant);
      this._swatchOption(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },


    /**
     * CUSTOM EVENT. If using buttons for our variants and linked options,
     * trigger change when selecting another button variant
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantButtonChange
     */
    _updateVariantButtons: function(variant) {
      this.$container.trigger({
        type: 'variantButtonChange',
        variant: variant
      });
    },


    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },

     /**
   * Clolor swatch option
   *
   * @param  {variant} variant - Currently selected variant
   */
  _swatchOption: function(variant) {
    if (variant) {
      ///this._onSwatchChange();
      var cls = '.variant-swatch-'+ variant.id;
      var form = jQuery(this.singleOptionSelector).closest('form');
      //console.log(this.singleOptionSelector);
      for (var i=0,length=variant.options.length; i<length; i++) {
        if(variant.available) {
          var radioButton = form.find('.swatch[data-option-index="' + i + '"] input[value="' + variant.options[i] +'"]');
           if (radioButton.length) {
             var val = radioButton.val();             
             radioButton.get(0).checked = true;
             if($(".size-text").length > 0) $(".js-" + val).removeClass("hide");
           }
        } else {
          $('.swatch[data-option-index="' + i + '"] .' + variant.options[i].toLowerCase() ).removeClass('available').addClass('soldout').find(':radio').attr('disabled');
        }
      }
    }
  }

  });

  return Variants;
})();




















/*==============================================================================
  #CONFIG & UTILITIES
==============================================================================*/

/**
 * There is no accurate way of detecting a touch device using JS. Ideally, you
 * would wait for a users first iteraction and determine if it's a touch or
 * mouse move:
 * https://blogs.perficientdigital.com/2017/11/21/detecting-the-use-of-a-touch-screen/
 *
 * `ontouchstart` is used by Modernizer:
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js#L40
 * 
 * `DocumentTouch`: very old and obsolete API since Gecko 25 (Firefox 25). Also
 * used by Modernizr.
 * https://developer.mozilla.org/en-US/docs/Web/API/DocumentTouch
 *
 * `maxTouchPoints`: returns number of touch contact points connected to the
 * device. Might not be best idea? Supported by Chrome Android, but not iOS.
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/maxTouchPoints
 *
 * `msMaxTouchPoints`: Only works for IE10. Future IEs removed this and used
 * standard `maxTouchPoints`:
 * https://technet.microsoft.com/en-us/windows/hh772144(v=vs.60)
 *
 * `matchMedia`: Similar to Prestige theme. matchMedia support is here:
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
 *
 * `moz-touch-events` no longer available to web content since Firefox 58:
 * https://developer.mozilla.org/en-US/docs/Web/CSS/@media/-moz-touch-enabled
 */


theme.config = {
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false || window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches,
  bpSmall: false
};





/**
 * Store our media queries here for easy use if we need breakpoints.
 */
theme.mq = {
  small: 'screen and (max-width: 767px)',
  medium: 'screen and (min-width: 768px) and (max-width: 1024px)',
  mediumUp: 'screen and (min-width: 768px)',
  large: 'screen and (min-width: 1025px) and (max-width: 1600px)',
  widescreen: 'screen and (min-width: 1601px)'
};





/**
 * A function to set the active breakpoint
 */
theme.setBreakpoints = function() {
  enquire.register(theme.mq.small, {
    match: function() {
      theme.config.small = true;
    },

    unmatch: function() {
      theme.config.small = false;
    }
  });
}










/*==============================================================================
  #CartUtilities
  - Ajax Shopify API Utilities
==============================================================================*/

theme.CartUtilities = {
  getCart: function() {
    return $.getJSON('/cart.js');
  },

  changeItem: function(key, qty) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&id=' + key,
      dataType: 'json'
    });
  },

  addItemFromForm: function(data) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json'
    });
  },

  _updateCart: function(params) {
    return $.ajax(params)
      .then(function(cart) {
        return cart;
      }.bind(this))
  },

  updateNote: function(note) {
    var params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + theme.CartUtilities.attributeToString(note),
      dataType: 'json',
      success: function(cart) {},
      error: function(XMLHttpRequest, textStatus) {}
    };

    $.ajax(params);
  },

  attributeToString: function(attribute) {
    if ((typeof attribute) !== 'string') {
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    return $.trim(attribute);
  }
}










/*==============================================================================
  #AjaxProduct
==============================================================================*/

theme.AjaxProduct = (function() {
  var status = {
    loading: false
  };

  function ProductForm($form) {
    this.$form = $form;
    this.$addToCart = this.$form.find('.js-add-to-cart');

    if (this.$form.length) {
      this.$form.on('submit', this.addItemFromForm.bind(this));
    }
  };

  ProductForm.prototype = $.extend({}, ProductForm.prototype, {
    addItemFromForm: function(evt, callback){
      evt.preventDefault();

      if (status.loading) {
        return;
      }

      // Loading indicator on add to cart button
      this.$addToCart.addClass('btn--loading');

      status.loading = true;

      var data = this.$form.serialize();

      theme.CartUtilities.addItemFromForm(data)
        .then(function(product) {
          this.success(product);
        }.bind(this))
        .catch(function(XMLHttpRequest) {
          this.error(XMLHttpRequest)
        }.bind(this))
        .always(function() {
          status.loading = false;
          this.$addToCart.removeClass('btn--loading');
        }.bind(this));
    },

    success: function(product) {
      this.$form.find('.alert--error').remove();
      $('body').trigger('added.ajaxProduct');
    },

    error: function(XMLHttpRequest) {
      this.$form.find('.alert--error').remove();

      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        console.warn(XMLHttpRequest.responseJSON.description);

        this.$addToCart.after('<div class="alert  alert--error  alert--spacing">' + XMLHttpRequest.responseJSON.description + '</div>');
      }
    }
  });

  return ProductForm;
})();










/*==============================================================================
  # Theme Load Image Section
  - Allows for adding classes whilst loading so we can animate
==============================================================================*/

theme.loadImageSection = function($container) {
  // Wait until images inside container have lazyloaded class
  function setAsLoaded() {
    $container.removeClass('loading loading--delayed').addClass('loaded');
  }

  function checkForLazyloadedImage() {
    return $container.find('.lazyloaded').length;
  }

  // If it has SVGs it's in the onboarding state so set as loaded
  if ($container.find('svg').length) {
    setAsLoaded();
    return;
  };

  if (checkForLazyloadedImage() > 0) {
    setAsLoaded();
    return;
  }

  var interval = setInterval(function() {
    if (checkForLazyloadedImage() > 0) {
      clearInterval(interval);
      setAsLoaded();
    }
  }, 80);
};




















/*==============================================================================
  #MODULES
==============================================================================*/

/*==============================================================================
  #CustomSelect
  - Used to style select elements with a replacement div
==============================================================================*/

theme.CustomSelect = function() {
  $('.custom-select__select').each(function(index, element) {
    var $element = $(element);
    var selectedValue = $element.children('option:selected').val();

    $element.parent().find('.custom-select__text').text(selectedValue);
  });

  $('.custom-select__select').on('change', function(evt) {
    var $this = $(this);
    var selectedValue = $this.children('option:selected').val();

    $this.parent().find('.custom-select__text').text(selectedValue);
  });
}










/*==============================================================================
  #CustomSwitcher
  - A custom dropdown / page switcher element
==============================================================================*/

theme.CustomSwitcher = function() {
  // event handler for button
  $('.custom-switcher-button').on('click', toggleSwitcher);

  // toggle switcher
  function toggleSwitcher(evt) {
    var $this = $(this);
    var $parent = $this.parent();

    if ($parent.hasClass('custom-switcher-wrapper--is-active')) {
      closeSwitcher($parent);
    } else {
      openSwitcher($parent);
    }
  }

  function openSwitcher($parent) {
    $parent.addClass('custom-switcher-wrapper--is-active');
    $parent.find('.custom-switcher-button').attr({
      'aria-expanded': 'true'
    });

    $parent.find('.custom-switcher').attr({
      'aria-hidden': 'false'
    });
  }


  function closeSwitcher($parent) {
    $parent.removeClass('custom-switcher-wrapper--is-active');
    $parent.find('.custom-switcher-button').attr({
      'aria-expanded': 'false'
    });

    $parent.find('.custom-switcher').attr({
      'aria-hidden': 'true'
    });
  }
}










/*==============================================================================
  #RegionSelect
  - Used to select the region / store domain
==============================================================================*/

theme.RegionSelect = function() {
  var $currencySelect = $('.js-currency-select');

  $currencySelect.on('change', function(evt) {
    var $this = $(this);
    var $selectedValue = $this.find(":selected").attr('data-url');
        //location.href = $selectedValue;
    //URL matched version
    let mysub = 'https://' +window.location.hostname;
    let myurl = window.location.href;
    let newurl = myurl.replace(mysub,$selectedValue);
    location.href = newurl;
  });
};











/*==============================================================================
  #HeaderNav
==============================================================================*/

theme.HeaderNav = (function() {
  var selectors = {
    body: 'body',
    header: '.header',
    itemHasDropdown: '.header-nav__item--main--has-dropdown',
    mainLinks: '.header-nav__link--main',
    childLinks: '.header-nav__link--child',
    grandchildLinks: '.header-nav__link--grandchild',

    activeDropdown: '.header-nav__item--main--dropdown-is-open',
    dropdown: '.dropdown'
  };


  var cache = {};


  var config = {
    activeDropdown: 'header-nav__item--main--dropdown-is-open',
    childLinks: 'header-nav__link--child',
    grandchildLinks: 'header-nav__link--grandchild',
    namespace: '.dropdown',
    transparentHeader: 'header--transparent',
    hasTransparentHeader: false
  }

  function cacheSelectors() {
    cache = {
      $window: $(window),
      $body: $(selectors.body),
      $header: $(selectors.header),
      $itemHasDropdown: $(selectors.itemHasDropdown),
      $mainLinks: $(selectors.mainLinks),
      $childLinks: $(selectors.childLinks),
      $grandchildLinks: $(selectors.grandchildLinks),
      $dropdown: $(selectors.dropdown)
    };
  }


  function init() {
    // Make our cached objects available
    cacheSelectors();

    // Initialise ARIA attributes
    cache.$itemHasDropdown.find(selectors.mainLinks).attr({
      'aria-haspopup': 'true',
      'aria-expanded': 'false'
    });

    if (cache.$header.hasClass(config.transparentHeader)) {
      config.hasTransparentHeader = true;
    }



    /**
     * 1. Dropdown click event handler 
     * The event handlers uses `evt.preventDefault()` to stop a link from 
     * firing, and allowing us to open or click a dropdown. This means that 
     * child links in our dropdown are also prevented from firing.
     */
    cache.$itemHasDropdown.on('click.' + config.namespace, toggleDropdown); /* [1] */

    /**
     * 2. Child and Grandchild Dropdown Links click event handler
     * Provides correct link behaviour to our child dropdown links. Our dropdown
     * click event handler prevents default link behaviour which also stops
     * our child dropdown links from firing. We use evt.stopPropagation on our 
     * child dropdown links to ensure they keep correct link behaviour.
     */
    cache.$childLinks.on('click' + config.namespace, function(evt) { /* [2] */
      evt.stopPropagation();
    });

    cache.$grandchildLinks.on('click' + config.namespace, function(evt) { /* [2] */
      evt.stopPropagation();
    });
  };



  /**
   * toggleDropdown function is bound to our dropdown click event handler, so
   * we pass in evt to our function.
   */

  function toggleDropdown(evt) {

    // `this` will refer to the dropdown we have clicked on. We wrap `this` in a
    // jQuery object.
    var $this = $(this);


    /**
     * 1. Prevent default link behaviour. This allows the dropdown to open or close
     * rather than the link click being fired and being sent to another page.
     * 
     * 2. We have a click event handler on our body that closes dropdowns. 
     * We need to stop immediate propagation so the click event doesn't bubble 
     * up to body level and close the dropdown straight after it is revealed,
     * and no other event handlers on the element or parent are fired that
     * interfere.
     */
    evt.preventDefault(); /* [1] */
    evt.stopImmediatePropagation(); /* [2] */

    /**
     * If dropdown is open, we close the dropdown. Else we open it. We pass in
     * `$this` which is our dropdown into our open or close functions.
     */
    if ($this.hasClass(config.activeDropdown)) {
      closeDropdown($this);
    } else {
      openDropdown($this);
    }
  };



  /**
   * Open Dropdown function. We take a parameter which is the active dropdown
   */
  function openDropdown($this) {

    /**
     * If an active dropdown is open, close it before opening another dropdown.
     * We do not use a cached selector such as $activeDropdown because that 
     * does not get updated when the DOM changes.
     */
    if ($(selectors.activeDropdown).length) {
      closeDropdown($(selectors.activeDropdown));
    }

    $('.header').addClass('header--dropdown-is-open');

    // Show dropdown by adding class that will display dropdown
    $this.addClass(config.activeDropdown);

    // ARIA set expanded to true
    $this.find(selectors.mainLinks).attr(
      {
        'aria-expanded': 'true'
      }
    );

    if ($this.hasClass('header-nav__item--search')) {
      setTimeout("$('.header-search__input').focus();", 500);      
    }

    /**
     * Attach event handlers to close the dropdown. These event handlers should
     * only fire when a dropdown is open.
     */

    // Close dropdown on click of body
    cache.$body.on('click' + config.namespace, function(evt) {
      closeDropdown($this);
    });

    // Ensure click in dropdown does not close dropdown
    cache.$dropdown.on('click' + config.namespace, function(evt) {
      evt.stopImmediatePropagation();
    });

    // Close dropdown on keypress of escape
    cache.$window.on('keyup' + config.namespace, function(evt) { /* [2] */
      if (evt.which === 27) {
        closeDropdown($this);
      }
    });
  };



  /**
   * Close Dropdown function. We take a parameter which is the active dropdown
   */
  function closeDropdown($this) {

    $('.header').removeClass('header--dropdown-is-open');

    // Hide dropdown by removing class in CSS, so dropdown will display:none
    $this.removeClass(config.activeDropdown);

    // ARIA set expanded to false
    $this.find(selectors.mainLinks).attr(
      {
        'aria-expanded': 'false'
      }
    );

    /**
     * Detach event handlers to close dropdown. These event handlers were
     * attached when the dropdown is open, but not needed when closed.
     */
    cache.$body.off('click' + config.namespace);
    cache.$window.off('keyup' + config.namespace);

  };



  /**
   * Revealing module pattern, we expose a specific part of our module to the
   * global scope.
   */

  return {
    init: init,
    openDropdown: openDropdown
  };
})(); /* end theme.HeaderNav */










/*==============================================================================
  #Modals
==============================================================================*/

theme.Modals = (function() {

  var selectors = {
    activeModal: '.modal--is-visible',
    openModal: '.js-open-modal',
    closeModal: '.js-close-modal',
    modalContent: '.modal__content'
  };

  var config = {
    activeModal: 'modal--is-visible',
    namespace: '.modal'
  }

  var $activeModal = $(selectors.activeModal);
  var modalIsOpen;
  var $html = $('html');

  if ($activeModal.length) {
    modalIsOpen = true;
  }

  function init() {
    $(selectors.openModal).on('click' + config.namespace, openModal);
    $(selectors.closeModal).on('click' + config.namespace, closeModal);
  }

  function openModal(evt) {

    // Make sure no other modal is already open. If so, close it.
    if (modalIsOpen) {
      closeModal();
    }

    evt.preventDefault();

    // Get Modal by ID tag. The aria-controls of the open button will match the ID of the modal.
    var $target = $(evt.currentTarget)
    var targetId = $target.attr('aria-controls');
    var $modal = $('#' + targetId);

    // Add active modal class
    $modal.addClass(config.activeModal);

    // Change aria-hidden
    $modal.attr('aria-hidden', 'false');

    // Add no scroll class to html
    $html.addClass('no-scroll');

    // Set $activeModal to the opened modal
    $activeModal = $modal;
    modalIsOpen = true;

    // Bind events
    bindEvents();
  }


  function closeModal(evt) {

    // Check that a modal is open. If not, return.
    if (!modalIsOpen) {
      return;
    }

    // Remove active class
    $activeModal.removeClass(config.activeModal);

    // Change aria-hidden
    $activeModal.attr('aria-hidden', 'true');

    // Remove no scroll class to html
    $html.removeClass('no-scroll');

    // Set $activeModal to false
    modalIsOpen = false;

    // Unbind Events
    unbindEvents();
  }


  function bindEvents() {

    // Close modal on ESC
    $(document).on('keyup' + config.namespace, function(evt) {
      if (evt.keyCode === 27) {
        closeModal();
      }
    })

    // Clicking outside of modal will close it
    $activeModal.on('click' + config.namespace, function(evt) {
      closeModal();
    });

    // However, we don't want it closed when clicking on modal content.
    $(selectors.modalContent).on('click' + config.namespace, function(evt) {
      evt.stopImmediatePropagation();
    });
  }


  function unbindEvents() {

    // Remove escape keyup event
    $(document).off('keyup' + config.namespace);

    // Remove $activeModal click
    if ($activeModal) {
      $activeModal.off('click' + config.namespace);
    }

    // Remove modalContent click
    $(selectors.modalContent).off('click' + config.namespace);
  }

  return {
    init: init
  }

})();










/*==============================================================================
  #Drawers

   - Largely based off Shopify Timber Drawers, with inspiration from Pushy JS,
      and Drawer.js
    
    WHAT IT DOES:
    - This allows us to create multiple off-canvas drawers
    - We use a constructor function and create an instance for each drawer we
      would like
    - We use prototypes to add methods to our constructor that can be shared
      amongst all our drawer instances
    - Due to using prototypes, we must use `this.[property]` to expose variables
      to our prototype methods.

    HOW TO USE:
    - Create an instance of a drawer such as:

    var drawerVariableName = new Drawer(drawerId, drawerName)
==============================================================================*/

theme.Drawers = (function() {

  function Drawer(drawerId, drawerName) {

    this.id = drawerId;
    this.name = drawerName;

    this.selectors = {
      html: document.documentElement,
      body: 'body',
      MainContent: '#MainContent',
      overlay: '.drawer-overlay',

      openBtn: '.js-drawer-open-' + drawerName,
      closeBtn: '.js-drawer-close'
    };

    this.cache = {
      $html: $(this.selectors.html),
      $body: $(this.selectors.body),
      $parent: $(this.selectors.html),
      $mainContent: $(this.selectors.mainContent),
      $overlay: $(this.selectors.overlay),

      $openBtn: $(this.selectors.openBtn),
      $closeBtn: $(this.selectors.closeBtn)
    };

    // Config object
    this.config = {
      open: 'js-drawer-is-open',
      noScroll: 'no-scroll',

      activeDrawer: 'drawer--is-open',
      activeOverlay: 'drawer-overlay--is-visible',

      namespace: '.drawer-' + name
    };

    // cache our drawer
    this.$drawer = $('#' + this.id);

    // Check if drawer exists
    if (!this.$drawer.length) {
      return false;
    }

    // Drawer flag to indicate if open or closed
    this.drawerIsOpen = false;

    // Last focus variable which will store the element that was focused prior
    // to opening the drawer
    this.$lastFocus = null;

    // Initialise our drawers
    this.init();
  };


  Drawer.prototype = $.extend({}, Drawer.prototype, {

    /* Drawer Init
     ======================================================================== */
    init: function() {
      var $openBtn = this.cache.$openBtn;

      // Attach aria-attributes on initialisation
      $openBtn.attr({
        'aria-controls': '#' + this.id,
        'aria-expanded': 'false'
      });

      /**
       * Open event handler. We use `.bind` to ensure that `this` refers to our 
       * Drawer object, not the jQuery object that is handling our event.
       */    
      $openBtn.on('click' + this.config.namespace, this.open.bind(this));
    },


    /* Drawer Open
     ======================================================================== */
    open: function(evt) {

      /**
       * When opening a drawer via a link we want to prevent the default 
       * behaviour of a link click event.
       *
       * When we open a drawer externally such as a Cart Drawer opening when 
       * an item is added to cart, `evt.preventDefault` encounters an error 
       * because there is no event, so evt is undefined.
       *
       * So, we use a conditional statement to check if our a drawer is opened
       * through an event/link click or externally.
       */
      if (evt) {
        evt.preventDefault();
      }

      // Defensive code to ensure that you can't open an already opened drawer
      if (this.drawerIsOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer. Doesn't cause issues for me.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();

        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }


      // Store our last focused element before opening the drawer as jQuery object
      this.$lastFocus = $(document.activeElement);

      // Show drawer
      this.$drawer.addClass(this.config.activeDrawer);

      // Add noScroll class to html/body
      this.cache.$parent.addClass(this.config.noScroll);
      this.cache.$overlay.addClass(this.config.activeOverlay);

      // Set active flag to true
      this.drawerIsOpen = true;

      // Trap focus to drawer
      slate.a11y.trapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      // Having this trigger, will allow us to close any modals/other elements
      // that may affect the drawer. An example is if we use a quickview modal
      // and add to cart, we want to close the modal, and open the cart drawer.
      $('body').trigger('drawerOpen.' + this.id);

      // Aria-expanded to true
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }

      // Bind close drawer event handlers
      this.bindEvents();
    },


    /* Drawer Close
     ======================================================================== */
    close: function(evt) {

      if (evt) {
        evt.preventDefault();
      }

      // Defensive code to ensure you can't close a closed drawer
      if (!this.drawerIsOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      // Close drawer
      this.$drawer.removeClass(this.config.activeDrawer);

      // Remove noScroll
      this.cache.$parent.removeClass(this.config.noScroll);
      this.cache.$overlay.removeClass(this.config.activeOverlay);

      // Set flag to false
      this.drawerIsOpen = false;

      // Remove focus
      slate.a11y.removeTrapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      // Aria-expanded to false
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false');
      }

      // Return focus to the element prior to opening our drawer    
      if (this.$lastFocus !== null) {
        this.$lastFocus.focus();     
      }

      // Unbind close drawer event handlers
      this.unbindEvents();
    },



    /* Drawer Bind Events
    ========================================================================= */
    bindEvents: function() {

      // Close on click of close button
      this.cache.$closeBtn.on('click' + this.config.namespace, this.close.bind(this));

      // Close on click of overlay
      this.cache.$overlay.on('click' + this.config.namespace, function (evt) {
          this.close();
      }.bind(this));

      // Close on keypress of escape key
      this.cache.$parent.on('keyup' + this.config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
    },


    /* Drawer Unbind Events
    ========================================================================= */
    unbindEvents: function() {
      this.cache.$parent.off(this.config.namespace);
      this.cache.$overlay.off(this.config.namespace);
      this.cache.$closeBtn.off(this.config.namespace);
    }

  });

  return Drawer;
})();










/*==============================================================================
  #DrawerSearch
  - On focus of menu drawer search input, we show recommended searches.
  - UNUSED: We have replaced this with a CSS only solution. There were issues
    on Safari. We relied on input focus to show a div with links. Clicking those
    links would not work as focus would be lost, meaning the div closed.
    CSS solution fixes this.
==============================================================================*/

theme.DrawerSearch = (function() {

  var $searchInput = $('.drawer-search__input');
  var $searchResults = $('.drawer-search__results');
  var activeClass = 'drawer-search__results--is-active';

  function init() {
    $searchInput.on('focus', function(evt) {
      focusSearch();
    });
  }

  function focusSearch() {
    $searchResults.addClass(activeClass);

    $searchInput.on('blur', function(evt) {
      unfocusSearch();
    });
  };

  // Blur and focusout events prevent link clicks. We need to prevent this so
  // links can be clicked.
  function unfocusSearch() {
    if($(event.relatedTarget).hasClass('drawer-search__link')) {
      event.preventDefault();
    } else {
      $searchResults.removeClass(activeClass);
    }
  };

  return {
    init: init,
    focusSearch: focusSearch
  }

})();










/*==============================================================================
  #Collapsibles
==============================================================================*/

/**
 * For smooth collapsibles we need to use height transitions. This is not 
 * supported in CSS, so we have to use JS.
 * https://css-tricks.com/using-css-transitions-auto-dimensions/#article-header-id-3
 */

theme.Collapsibles = (function() {

  var selectors = {
    keepMultipleOpen: '[data-keep-multiple-collapsibles-open]',
    collapsible: '.collapsible',
    button: '.collapsible__heading',
    panel: '.collapsible__panel',
    panelContent: '.collapsible__panel-content',
    activeCollapsible: '.collapsible--is-open'
  };

  var config = {
    activeCollapsible: 'collapsible--is-open',
    keepMultipleOpen: false
  }


  function init() {
    // Event handler on click
    $(selectors.button).on('click', function(evt) {

      // Get current event target which will be the collapsible button
      var $target = $(evt.currentTarget);

      // Get keepMultipleOpen selector if it exists
      var $keepMultipleOpen = $target.closest(selectors.keepMultipleOpen);

      /**
       * If we have a data-keep-multiple-collapsibles-open attribute on the
       * collapsible wrapper, we set the flag to true.
       */

      if ($keepMultipleOpen.length) {
        config.keepMultipleOpen = true;
      } else {
        config.keepMultipleOpen = false;
      }


      /**
       * If we have nested collapsibles, we ensure that click events don't bubble
       * so a nested collapsible doesn't open and then close.
       */
      evt.stopPropagation();

      // Pass our $target to toggleCollapsible function
      toggleCollapsible($target);
    });
  };



  // Pass in our $target element (the button that was clicked)
  function toggleCollapsible($target) {

    // Get the parent collapsible
    var $parentCollapsible = $target.closest(selectors.collapsible);

    // Get the collapsiblePanel
    var $collapsiblePanel = $parentCollapsible.find('> ' + selectors.panel);;


    /**
     * Check if the collapsible is open or closed and run the relevant function
     * passing in the parentCollapsible and collapsiblePanel
     */
    if ($parentCollapsible.hasClass(config.activeCollapsible)) {
      closeCollapsible($parentCollapsible, $collapsiblePanel);
    } else {
      openCollapsible($parentCollapsible, $collapsiblePanel);
    }


    /**
     * If we want only one collapsible open at a time, we run this function
     * to close sibling collapsibles
     */
    if (!config.keepMultipleOpen) {

      $parentCollapsible.siblings(selectors.collapsible).each(function(index, element) {

        // This stores all parentCollapsibles
        var $parent = $(element);

        // This stores all collapsiblePanels
        var $panel = $parent.find('> ' + selectors.panel);

        closeCollapsible($parent, $panel);
      });
    }
  };


  // Pass in the parent collapsible, and collapsible panel
  function openCollapsible($parentCollapsible, $collapsiblePanel) {

    // If already open, skip this function
    if ($parentCollapsible.hasClass(config.activeCollapsible)) {
      return;
    }

    /**
     * As we may have nested collapsibles, we need to ensure we get the direct
     * descendant toggleButton
     */
    var $toggleButton = $parentCollapsible.find('> ' + selectors.button);

    // Add aria expanded
    $toggleButton.attr('aria-expanded', true);


    // Get panel height
    var panelHeight = $collapsiblePanel.first().prop("scrollHeight");

    // We need to declare an explicit height before setting to auto
    $collapsiblePanel.css({
      'overflow': 'visible',
      'height' : panelHeight + 'px'
    });

    // On completion of CSS transition, we set height to auto
    var transitionEnded = function transitionEnded(evt) {
      console.log('transitionend');
      if (evt.originalEvent.propertyName === 'height') {
        $collapsiblePanel.css('height', 'auto');
        $collapsiblePanel.off('transitionend');
      }
    };

    $collapsiblePanel.on('transitionend', transitionEnded);

    // Add active class. This needs to be placed last to not interfere with
    // CSS height changes
    $parentCollapsible.addClass(config.activeCollapsible);

  }


  function closeCollapsible($parentCollapsible, $collapsiblePanel) {

    // If already closed, skip this function
    if (!$parentCollapsible.hasClass(config.activeCollapsible)) {
      return;
    }

    /**
     * As we may have nested collapsibles, we need to ensure we get the direct
     * descendant toggleButton
     */
    var $toggleButton = $parentCollapsible.find('> ' + selectors.button);

    // Add aria expanded
    $toggleButton.attr('aria-expanded', false);

    var panelHeight = $collapsiblePanel.first().prop("scrollHeight");

    $collapsiblePanel.css({
      'overflow': 'hidden',
      'height' : panelHeight + 'px'
    });

    var offsetHeight = $collapsiblePanel.outerHeight();

    $collapsiblePanel.css({
      'height' : offsetHeight + 'px'
    });

    $collapsiblePanel.css({
      'height' : '0'
    });

    // Remove active class. This needs to be placed last to not interfere with
    // CSS height changes
    $parentCollapsible.removeClass(config.activeCollapsible);
  }


  return {
    init: init
  };
})();










/*==============================================================================
  #Tabs
==============================================================================*/

theme.Tabs = (function() {

  var config = {
    activeTab: 'tab--is-active'
  }

  function init() {
  }

  $('.tab').on('click', function(evt) {

    var $this = $(this);

    if ($this.hasClass(config.activeTab)) {
      return;
    }

    // Get Tab ID
    var tabId = $this.find('span').attr('id');

    /**
     * As we may have multiple tab components, we make heavy use of the parent()
     * selector. This ensures one tab component doesn't affect another.
     */
    // Remove active class and ARIA
    $this.parent().find('.tab').removeClass(config.activeTab);
    $this.parent().parent().find('.tab__panel').removeClass(config.activeTab).attr('aria-hidden', 'true');
    $this.parent().find('.tab > [aria-selected="true"]').attr('aria-selected', 'false');

    // Add active classes and ARIA
    $this.addClass(config.activeTab);
    $this.parent().parent().find('[aria-labelledby="tab-' + tabId + '"]').addClass(config.activeTab).attr('aria-hidden', 'false');
  });

  return {
    init: init
  }
})();










/*==============================================================================
  #AJAX Newsletter Form - Mailchimp
==============================================================================*/

theme.ajaxNewsletterForm = function() {

  // Set variables for footer and popup classes
  var $newsletterFooter = $('.js-newsletter-footer');
  var $newsletterPopup = $('.js-newsletter-popup');

  var $newsletterFooterResponse = $('.js-newsletter-footer-response');
  var $newsletterPopupResponse = $('.js-newsletter-popup-response');


  // If a user is subscribed, set the cookie to not expire for 10000 days.
  function setSubscribedCookie() {
    Cookies.set('newsletter-subscribed', true, {
      expires: 10000
    });
  }


  // Our submit event listener for a specific form
  function ajaxMailChimpForm($form, $responseElement) {
    $form.submit(function(evt){
      evt.preventDefault();
      submitForm($form, $responseElement);
    });
  }


  // Submit form event handler
  function submitForm($form, $responseElement) {
    $.ajax({
      type: "GET",
      url: $form.attr("action"),
      data: $form.serialize(),
      cache: false,
      dataType: "jsonp",
      jsonp: "c", // trigger MailChimp to return a JSONP response
      contentType: "application/json; charset=utf-8",

      error: function(error) {
        // According to jquery docs, this is never called for cross-domain JSONP requests
        alert("Could not connect to the server. Please try again later.");
      },

      success: function(data) {
        var successMessage = $('.newsletter-response').attr('data-newsletter-success');
        var alreadySubscribedMessage = $('.newsletter-response').attr('data-newsletter-already-subscribed');

        if (data.result != "success") {

          if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
            $responseElement.removeClass('newsletter-alert--success').addClass('newsletter-alert--error');
            $responseElement.html(alreadySubscribedMessage).show();
            setSubscribedCookie();

          } else {
            $responseElement.removeClass('newsletter-alert--success').addClass('newsletter-alert--error');
            $responseElement.html(data.msg).show();
          }

        } else {
          $responseElement.removeClass('newsletter-alert--error').addClass('newsletter-alert--success');
          $responseElement.html(successMessage).show();
          setSubscribedCookie();
        }
      }
    });
  }

  // Run the code for each newsletter form on your page
  ajaxMailChimpForm($newsletterFooter, $newsletterFooterResponse);
  ajaxMailChimpForm($newsletterPopup, $newsletterPopupResponse);
}




















/*==============================================================================
  #SECTIONS
==============================================================================*/

/*==============================================================================
  #HeaderSection
==============================================================================*/

theme.HeaderSection = (function() {

  function Header(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var selectors = this.selectors = {
      header: '.header',
      announcementBar: '.announcement-bar',
      announcementClose: '.js-announcement-bar-close'
    };

    var cache = this.cache = {
      $header: $(this.selectors.header),
      $announcementBar: $(this.selectors.announcementBar),
      $announcementClose: $(this.selectors.announcementClose)
    };

    var config = this.config = {
      headerHasScrolled: 'header--has-scrolled',
      headerBg: 'header--bg',
      announcementActiveClass: 'announcement-bar--is-active',
      announcementExpiry: this.options['announcementDays'],
      headerNamespace: '.header'
    };


    /**
     * If announcement bar enabled, we show it.
     */
    if (this.options['showAnnouncementBar']) {
      this.initAnnouncementBar();
    }


    // Header scroll variables
    var prevScrollPos = 0;
    var hasScrolledUp = false;

    theme.HeaderNav.init();
    this.initDrawers();

    /**
     * Scroll event listener for header.
     * Use a throttle of 16 that matches 60fps.
     */
    $(window).on('scroll' + config.headerNamespace, $.throttle(16, onScroll).bind(this));


    /**
     * Mousenter event handler for header. On scroll down, the header is hidden.
     * On mouseenter, we show the header.
     */
    cache.$header.on('mouseenter' + config.headerNamespace, function(evt) {
      if (cache.$header.hasClass(config.headerHasScrolled)) {
        return;
      } else {
        cache.$header.addClass(config.headerBg);
      }
    });

    cache.$header.on('mouseleave' + config.headerNamespace, function(evt) {
      if (cache.$header.hasClass(config.headerHasScrolled) || cache.$header.hasClass('header--dropdown-is-open')) {
        return;
      } else {
        cache.$header.removeClass(config.headerBg);
      }
    });


    /**
     * Scroll event handler. On scroll down, we hide the header. On scroll up,
     * we show the header.
     */
    function onScroll() {
      // var headerHeight = 150;
      var scrollPos = window.scrollY;
      var scrollThreshold = 200;

      if (scrollPos > scrollThreshold) {
        cache.$header.addClass(config.headerHasScrolled);
        cache.$header.addClass('header--is-fixed');
      } else {
        cache.$header.removeClass(config.headerHasScrolled);
        cache.$header.removeClass('header--is-fixed');
      }

      prevScrollPos = scrollPos;
    }
  }

  Header.prototype = $.extend({}, Header.prototype, {

    initDrawers: function() {
      theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');

      if (theme.settings.cartType === 'drawer') {
        theme.CartDrawer = new theme.Drawers('CartDrawer', 'cart');
      }
    },

    initAnnouncementBar: function() {

      /**
       * 1. The announcement bar is hidden by default in our stylesheet. We use
       *    cookies to check if a user has closed the bar. If they have, we 
       *    don't run the code.
       * 
       * 2. We have a displayMode called 'Testing'. This allows the merchant to
       *    override the cookie settings in the Theme Editor so they can make
       *    edits.
       */

      if (this.options['announcementDisplayMode'] == 'enabled') {
        if (Cookies.get('announcementBar') == 'closed') {
          return; /* [1] */
        } else {
          this.showAnnouncementBar();
        }
      } else if (this.options['announcementDisplayMode'] == 'testing') {
        this.resetAnnouncementBar(); /* [2] */
      }


      /**
       * Event handler to close the announcement bar on click.
       * Hides the announcement bar and sets a cookie with an expiry set by
       * the merchant in the Theme Editor.
       */

      this.cache.$announcementClose.on('click', function(evt) {
        this.hideAnnouncementBar();

        Cookies.set('announcementBar', 'closed', { expires: this.config.announcementExpiry });
      }.bind(this));
    },


    showAnnouncementBar: function() {
      this.cache.$announcementBar.addClass(this.config.announcementActiveClass);

      // Reevaluate header height when announcement is open
      document.documentElement.style.setProperty('--header-height', document.getElementById('Section--header').offsetHeight + 'px');
    },


    hideAnnouncementBar: function() {
      this.cache.$announcementBar.removeClass(this.config.announcementActiveClass);

      // Reevaluate header height when announcement is closed
      document.documentElement.style.setProperty('--header-height', document.getElementById('Section--header').offsetHeight + 'px');
    },


    resetAnnouncementBar: function() {
      Cookies.remove('announcementBar');
      this.showAnnouncementBar();
    },

    /**
     * Shopify Theme Editor events
     */

    onSelect: function() {
      theme.HeaderNav.init();
      this.resetAnnouncementBar();
    }

  });

  return Header;

})();











/*==============================================================================
  #DrawerMenuSection
  - Our Drawer Menu is registered as a section hence a separate JS section
    module. Majority of functions here ensure the drawer works smoothly in
    the Theme Editor.
==============================================================================*/

theme.DrawerMenuSection = (function() {

  function DrawerMenuSection(container) {
    this.init();
  }

  DrawerMenuSection.prototype = $.extend({}, DrawerMenuSection.prototype, {

    init: function() {
      this.onUnload();

      theme.DrawerMenu = new theme.Drawers('NavDrawer', 'nav');
    },

    /**
     * Shopify Theme Editor events
     */

    forceReload: function() {
      this.init();
    },

    onSelect: function() {
      theme.DrawerMenu.open();
      // theme.Collapsibles.init();
    },

    onDeselect: function() {
      theme.DrawerMenu.close();
    },

    onUnload: function() {
      if (theme.DrawerMenu) {
        theme.DrawerMenu.close();
      }
    }
  });

  return DrawerMenuSection;
})();










/*==============================================================================
  #PopupSection
==============================================================================*/

theme.PopupSection = (function() {

  function PopupSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    // Store our selectors
    this.selectors = {
      popup: '.popup',
      popupActive: '.popup--is-visible',
      popupContent: '.popup__content',
      popupClose: '.js-popup-close'
    };

    // Cache selectors
    this.cache = {
      $popup: $(this.selectors.popup),
      $popupClose: $(this.selectors.popupClose)
    };

    // Config and active classes
    this.config = {
      popupActiveClass: 'popup--is-visible',
      popupExpiry: this.options['popupDays'],
      namespace: 'popup'
    };

    if (this.options['showPopup']) {
      this.initPopup();
    }

  }

  PopupSection.prototype = $.extend({}, PopupSection.prototype, {

    initPopup: function() {

      /**
       * 1. The popup is hidden by default in our stylesheet. We use
       *    cookies to check if a user has closed the popup. If they have, we 
       *    don't run the code.
       * 
       * 2. We have a displayMode called 'Testing'. This allows the merchant to
       *    override the cookie settings in the Theme Editor so they can make
       *    edits.
       */

      if (this.options['popupDisplayMode'] == 'enabled') {
        if (Cookies.get('newsletter-subscribed') || Cookies.get('popup') == 'closed') {
          return; /* [1] */
        } else {
          setTimeout(function() {
            this.showPopup();
          }.bind(this), this.options['popupDelay'] * 1000);
        }
      } else if (this.options['popupDisplayMode'] == 'testing') {
        this.resetPopup(); /* [2] */
      }


      /**
       * Event handler to close the popup on click.
       * Hides the popup and sets a cookie with an expiry set by
       * the merchant in the Theme Editor.
       */

      this.cache.$popupClose.on('click', function(evt) {
        this.hidePopup();

        Cookies.set('popup', 'closed', { expires: this.config.popupExpiry });
      }.bind(this));



      /**
       * Event handler to close the popup when clicking outside.
       * Hides the popup and sets a cookie with an expiry set by
       * the merchant in the Theme Editor.
       */

      this.cache.$popup.on('click.popup', function(evt) {
        this.hidePopup();

        Cookies.set('popup', 'closed', { expires: this.config.popupExpiry });
      }.bind(this));


      /**
       * Make sure the popup doesn't close when clicking on the popup itself.
       */

      $(this.selectors.popupContent).on('click.popup', function(evt) {
        evt.stopImmediatePropagation();
      }.bind(this));

    },


    showPopup: function() {
      this.cache.$popup.addClass(this.config.popupActiveClass);
      $('body').addClass('no-scroll');
    },


    hidePopup: function() {
      this.cache.$popup.removeClass(this.config.popupActiveClass);
      $('body').removeClass('no-scroll');

      this.cache.$popup.off('click.popup');

      $(this.selectors.popupContent).off('click.popup');
    },


    resetPopup: function() {
      Cookies.remove('popup');
      this.showPopup();
    },


    onSelect: function() {
      this.resetPopup();
    }

  });

  return PopupSection;

})();










/*==============================================================================
  #CookiesSection
==============================================================================*/

theme.CookiesSection = (function() {

  function CookiesSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    // Store our selectors
    this.selectors = {
      cookiesBar: '.cookies-bar',
      cookiesBarClose: '.js-cookies-bar-close'
    };

    // Cache selectors
    this.cache = {
      $cookiesBar: $(this.selectors.cookiesBar),
      $cookiesBarClose: $(this.selectors.cookiesBarClose)
    };

    // Config and active classes
    this.config = {
      cookiesBarActiveClass: 'cookies-bar--is-active'
    };

    if (this.options['showCookiesBar']) {
      this.initCookiesBar();
    }

  }

  CookiesSection.prototype = $.extend({}, CookiesSection.prototype, {

    initCookiesBar: function() {

      /**
       * 1. The cookies bar is hidden by default in our stylesheet. We use
       *    cookies to check if a user has closed the bar. If they have, we 
       *    don't run the code.
       * 
       * 2. We have a displayMode called 'Testing'. This allows the merchant to
       *    override the cookie settings in the Theme Editor so they can make
       *    edits.
       */

      if (this.options['cookiesDisplayMode'] == 'enabled') {
        if (Cookies.get('cookies') == 'accepted') {
          return; /* [1] */
        } else {
          this.showCookiesBar();
        }
      } else if (this.options['cookiesDisplayMode'] == 'testing') {
        this.resetCookiesBar(); /* [2] */
      }


      /**
       * Event handler to close the announcement bar on click.
       * Hides the announcement bar and sets a cookie with an expiry set by
       * the merchant in the Theme Editor.
       */

      this.cache.$cookiesBarClose.on('click', function(evt) {
        this.hideCookiesBar();
        Cookies.set('cookies', 'accepted', { expires: 365 });
      }.bind(this));
    },


    showCookiesBar: function() {
      this.cache.$cookiesBar.addClass(this.config.cookiesBarActiveClass);
    },


    hideCookiesBar: function() {
      this.cache.$cookiesBar.removeClass(this.config.cookiesBarActiveClass);
    },


    resetCookiesBar: function() {
      Cookies.remove('cookies');
      this.showCookiesBar();
    },


    onSelect: function() {
      this.resetCookiesBar();
    }

  });

  return CookiesSection;

})();










/*==============================================================================
  #Cart
  - This code handles major cart related functionality on both the cart page and
    the AJAX cart drawer.
==============================================================================*/

theme.Cart = (function() {

  var itemCount = window.theme.settings.cartCount;
  var loading = false;


  function init() {
    /**
     * On custom event `added.ajaxProduct` we run buildCart. This is triggered 
     * in `theme.ProductForm`. We don't place this in our initEventListeners()
     * function as we don't need to re-run this, as it's triggered elsewhere.
     *
     * The function will run the AJAX request to get our cart. We need to pass
     * this cart object in to our buildCart function.
     */
    $('body').on('added.ajaxProduct', function() {
      theme.CartUtilities.getCart().then(function(cart) {
        buildCart(cart);
      }.bind(this));
    }.bind(this));

    // Store cart note when AJAX cart changes
    $('body').on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();
      theme.CartUtilities.updateNote(newNote);
    });
    
    initEventListeners();
  };


  function initEventListeners() {

    /**
     * Quantity related event listeners
     */
    $('.js-qty-increase').on('click', updateQuantity);
    $('.js-qty-decrease').on('click', updateQuantity);
    $('.js-qty-input').on('blur', updateQuantity);
  };


  function updateQuantity(evt) {

    // Prevent default link behaviour for remove link
    evt.preventDefault();

    // Store our target element
    var $target = $(evt.currentTarget);

    // Set quantity
    var parsedQuantity = 1;

    // Get variant ID
    var id = $target.attr('data-line-id');

    // If target is our input element
    if ($target.hasClass('js-qty-input')) {

      // Get the current value
      var currentValue = parseInt($target.attr('data-current-value'));

      // Get the new user-input value
      parsedQuantity = parseInt($target.val());

      // Check that new user-input value is a number. If not, default to the current value.
      if (!Number.isInteger(parsedQuantity)) {
        parsedQuantity = currentValue;
      }

      // Set the input element to our new user-input value or current value
      $target.val(parsedQuantity);

      // Return if current value is same as new value
      if (currentValue === parsedQuantity) {
        return;
      }
    } else {

      // Get new quantity if using the +/- increment buttons
      parsedQuantity = $target.attr('data-quantity');

      // Set our input as the new quantity
      $target.siblings('.js-qty-input').val(parsedQuantity);
    }

    // Run updateItem with our event, variant ID, and new quantity
    updateItem(evt, id, parsedQuantity);
  };


  function updateItem(evt, id, qty) {
    if (loading) {
      return;
    }

    loading = true;

    theme.CartUtilities.changeItem(id, qty)
      .then(function(cart) {
        updateSuccess(cart);
      }.bind(this))
      .catch(function(XMLHttpRequest) {
        updateError(XMLHttpRequest)
      }.bind(this))
      .always(function() {
        loading = false;
      }.bind(this));
  };


  function buildCart(cart) {

    loading = true;

    var cart = cart;
    var url = '';

    /**
     * Depending on whether we're on the cart template or outside of it, we pull
     * in a specific cart template. We're not using a templating library such as
     * Handlebars. This is a potentially more app-friendly solution as we can
     * re-run liquid. This solution is influenced by Maestrooo on their Prestige
     * and Warehouse themes.
     */
    if (window.theme.settings.template !== 'cart') {
      url = '/cart?view=drawer&timestamp=' + Date.now();
    } else {
      url = '/cart?timestamp=' + Date.now();
    }

    $.ajax(url, {
        method: 'GET',
        dataType: 'html'
      })
      .done(function(data, textStatus, jqXHR) {

        if (window.theme.settings.template !== 'cart' && window.theme.settings.cartType === 'drawer') {
          
          // Update Cart Drawer Items
          var tempElement = document.createElement('div');
          tempElement.innerHTML = data;

          var cartNodeParent = document.querySelector('.js-cart-content').parentNode;

          cartNodeParent.replaceChild(tempElement.querySelector('.js-cart-content'), document.querySelector('.js-cart-content'));

          theme.CartDrawer.open();

        } else {
          // We are forcing a location reload on the cart page to ensure we run
          // any necessary JS for 3rd party apps etc.
          window.location.reload();
        }

      })
      .fail(function() {
        console.log("error");
      })
      .always(function() {
        loading = false;
        initEventListeners();
      });


    if (cart.items.length > 0) {
      $('.header__cart-dot').addClass('header__cart-dot--is-visible');
    } else {
      $('.header__cart-dot').removeClass('header__cart-dot--is-visible');
    }
  };


  function updateSuccess(cart) {
    buildCart(cart);
  };


  function updateError(XMLHttpRequest) {
    if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
      console.warn(XMLHttpRequest.responseJSON.description);
    }
  };

  return {
    init: init
  };

})();










/*==============================================================================
  #Product
==============================================================================*/

theme.Product = (function() {

  var selectors = {};

  var config = {};

  function Product(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    this.settings = {
      enableHistoryState: this.options['enableHistoryState'],
      hasInstagram: this.options['hasInstagram'],
      namespace: '.product-' + sectionId,
      slickMainInitialized: false,
      imageSize: '620x'
      //swatch: true,
    };


    this.selectors = {
      productJson: 'ProductJson-' + sectionId,

      swatchSelector: '.swatch :radio',

      productMainSlider: '.js-product-slider-' + sectionId,

      price: '.js-product-price-' + sectionId,
      comparePrice: '.js-product-compare-price-' + sectionId,

      addToCart: '.js-add-to-cart-' + sectionId,
      addToCartText: '.js-add-to-cart-text-' + sectionId,

      originalSelectorId: '.js-product-form-selector-master-' + sectionId,
      singleOptionSelector: '.js-product-form-selector-' + sectionId,

      formContainer: '.js-product-form-' + sectionId
    };

    // Check this is a product object
    if (!$('#' + this.selectors.productJson).html()) {
      return;
    }

    // Parse our product json object
    this.productObject = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML);


    // Cache slider and image variables
    this.$productMainSlider = $(this.selectors.productMainSlider);

    // We get our first product image
    this.$firstProductImage = this.$productMainSlider.find('img').first();


    // Share functionality
    var shareIsOpen = this.shareIsOpen = false;

    // Attach share listener
    $('.js-product-share-btn').on('click', this.toggleShare.bind(this));


    // Initialise section
    this.init();
  }


  Product.prototype = $.extend({}, Product.prototype, {

    init: function() {
      this.productFormSetup();
      this.createImageSlider();
      this.initBreakpoints();

      if (this.settings.hasInstagram) {
        this.initInstagram();
      }
    },


    initBreakpoints: function() {
      var self = this;

      enquire.register(theme.mq.mediumUp, {
        match: function() {
          self.initImageZoom();
        }
      });

      enquire.register(theme.mq.small, {
        match: function() {
          self.destroyImageZoom();
        }
      });
    },


    productFormSetup: function() {
      this.initQtySelector();
      this.initAjaxProductForm();
      this.initVariants();
    },


    toggleShare: function() {
      var self = this;

      if (self.shareIsOpen) {
        $('.product__share').removeClass('product__share--is-open');
        self.shareIsOpen = false;
      } else {
        $('.product__share').addClass('product__share--is-open');
        self.shareIsOpen = true;
      }
    },


    initInstagram: function() {
      // Initialise instagram slider
      $('.js-product-instagram-slider').slick({
        rows: 0,
        adaptiveHeight: false,
        centerMode: true,
        centerPadding: '100px',
        arrows: true,
        prevArrow: $('.instagram__arrow--prev'),
        nextArrow: $('.instagram__arrow--next'),
        dots: false,
        slidesToShow: 5,
        touchThreshold: 20,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              centerPadding: '40px',
            }
          }
        ]
      });
    },


    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        swatchSelector: this.selectors.swatchSelector,
        product: this.productObject
      }

      this.variants = new slate.Variants(options);

      this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
      this.$container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
    },


    updatePrice: function(evt) {

      var variant = evt.variant;

      if (variant) {
        
        // get tax price and multiplier with price if variant get
        if($("section.product-section").attr("data-tax-multiplier")){
          var tax = $("section.product-section").attr("data-tax-multiplier");
        }

        if(tax){
          var vPrice = slate.Currency.formatMoney(variant.price*tax, theme.settings.moneyFormat);
        }else{
          var vPrice = slate.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
        }

        // Update current price
        $(this.selectors.price).html(vPrice);

        if (variant.compare_at_price > variant.price) {
          
          if(tax){
            var vComparePrice = slate.Currency.formatMoney(variant.compare_at_price*tax, theme.settings.moneyFormat);
          }else{
            var vComparePrice = slate.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
          }

          // If on sale, update compare at price (aka regular price)
          $(this.selectors.comparePrice).html(vComparePrice);
        }
      }
    },


    updateCartButton: function(evt) {

      var variant = evt.variant;
      var $dynamicPaymentButton;

      if (this.settings.showPaymentButton) {
        $dynamicPaymentButton = $('.shopify-payment-button');
      }

      if (variant) {

        if (variant.available) {

          // Remove disabled attribute and show Add to Cart text
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).html(theme.strings.addToCart);

          if (this.settings.showPaymentButton) {
            $dynamicPaymentButton.show();
          }

        } else {

          // Add disabled attribute and show Sold Out text
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.soldOut);
          if (this.settings.showPaymentButton) {
            $dynamicPaymentButton.hide();
          }
        }

      } else {

        // If variant does not exist 
        // Add disabled attribute and show Unavailable text
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).html(theme.strings.unavailable);
        if (this.settings.showPaymentButton) {
          $dynamicPaymentButton.hide();
        }
      }
    },


    updateVariantImage: function(evt) {
      
      // variantImageChange evt stores our variant object
      var variant = evt.variant;

      // These size variables aren't needed for current slider implementation
      // var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      // var zoomSizedImgUrl;

      // if (this.settings.enableImageZoom && theme.config.isTouch) {
      //   zoomSizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
      // }


      // Retrieve index of our new image
      var $newImage = $('.product__image-slide[data-id="' + variant.featured_image.id + '"]');
      var imageIndex = this._slideIndex($newImage);

      // If there is no index, slider is not initalized
      if (typeof imageIndex === 'undefined') {
        return;
      }

      // Go to slide
      this.$productMainSlider.slick('slickGoTo', imageIndex);
    },


    // Unused function for quantity selector
    initQtySelector: function() {
      $(this.selectors.qtyDecrease).on('click', function(evt) {
        var target = evt.currentTarget;
        target.nextElementSibling.value = Math.max(parseInt(target.nextElementSibling.value) - 1, 1);
      });

      $(this.selectors.qtyIncrease).on('click', function(evt) {
        var target = evt.currentTarget;
        target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1;
      });
    },


    initAjaxProductForm: function() {
      // If we are using a AJAX drawer, pass our form to AjaxProduct function
      if (theme.settings.cartType === 'drawer') {
        new theme.AjaxProduct($(this.selectors.formContainer));
      }
    },


    createImageSlider: function() {
      // Default slider settings
      this.productMainSliderArgs = {
        infinite: false,
        arrows: true,
        prevArrow: $('.product-slider-controls__arrow--prev'),
        nextArrow: $('.product-slider-controls__arrow--next'),
        dots: false,
        fade: true,
        adaptiveHeight: false,
        rows: 0
      };

      // Lame way to prevent duplicate event listeners
      this.$productMainSlider.off('afterChange');
      this.$productMainSlider.on('afterChange', this.afterSlideChange.bind(this));

      this.initSlider(this.productMainSliderArgs);
    },


    initSlider: function(args) {
      this.destroyImageSlider();

      this.$productMainSlider.slick(this.productMainSliderArgs);

      this.settings.slickMainInitialized = true;
    },


    destroyImageSlider: function() {
      if (this.$productMainSlider && this.settings.slickMainInitialized) {
        this.$productMainSlider.slick('unslick');
        this.settings.slickMainInitialized = false;
      }
    },


    afterSlideChange: function(event, slick, currentSlide, nextSlide) {
      // After slide change, we update the slide counter
      $('.js-slide-current').text(currentSlide + 1);
    },

    // Get slide index
    _slideIndex: function($el) {
      return $el.data('index');
    },


    // Init PhotoSwipe Image Zoom lightbox
    initImageZoom: function(evt) {

      //Init event listener
      $('.product__image-slide').on('click', this.initPhotoSwipeFromImageClick.bind(this));
    },

    destroyImageZoom: function(evt) {
      $('.product__image-slide').off('click');
    },


    initPhotoSwipeFromImageClick: function(evt) {

      // Store index of clicked image so we ensure to show this
      // when popup opens
      var imageIndex = parseInt(evt.currentTarget.getAttribute('data-image-index'), 0);

      // An array to store all images
      var images = [];
      var $this = $(this);

      // Find all images and push to images array
      $('.product__image-slide').each(function(index, element) {
        var $image = $(element).find('img');
        images.push($image);
      });

      this.createPhotoSwipeInstance(this.createPhotoSwipeItemsFromImages(images), imageIndex);
    },


    createPhotoSwipeItemsFromImages: function(images) {
      return $.map(images, function(image, index) {

        var $image = $(image);
        var maxWidth = parseInt($image.attr('data-max-width'));
        var maxHeight = parseInt($image.attr('data-max-height'));

        var zoomImgSrc = slate.Image.getSizedImageUrl($image.attr('data-zoom-src'), maxWidth + 'x' + maxHeight);

        var $imageCurrentSrc = $image.prop('currentSrc');
        var $imageSrc = $image.prop('src');

        return {
          w: maxWidth,
          h: maxHeight,
          src: zoomImgSrc
        };
      });
    },


    createPhotoSwipeInstance: function(items, selectedImageIndex) {
      var photoSwipeContainer = document.querySelector('.pswp');

      this.photoSwipeInstance = new PhotoSwipe(photoSwipeContainer, false, items, {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: false,
        allowPanToNext: false,
        pinchToClose: false,
        closeOnScroll: false,
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.33;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        }
      });

      // Update the slide counter
      $('.pswp__counter--current').text(selectedImageIndex);

      // Event listeners
      this.photoSwipeInstance.listen('destroy', this.destroyPhotoSwipe.bind(this));
      this.photoSwipeInstance.listen('beforeChange', this.onSlideChanged.bind(this));

      $('body').on('pswpTap', '.pswp__scroll-wrap', function(evt) {
        this.onSingleTap(evt, this.photoSwipeInstance);
      }.bind(this));

      $('body').on('pswpTap', '.pswp__button--arrow--left', this.photoSwipeInstance.prev);

      $('body').on('pswpTap', '.pswp__button--arrow--right', this.photoSwipeInstance.next);

      $('body').on('pswpTap', '.pswp__button--close', this.photoSwipeInstance.close);

      this.photoSwipeInstance.init();
    },


    // Event handler to zoom in
    onSingleTap: function(evt, photoSwipeInstance) {
      if (!evt.detail || evt.detail.pointerType === 'mouse') {
        if (evt.target.classList.contains('pswp__img')) {
          this.photoSwipeInstance.toggleDesktopZoom(evt.detail.releasePoint);
        }
      } else {
        if (evt.target.classList.contains('pswp__button')) {
          return;
        }
      }
    },


    // On slide change, we update the counter
    onSlideChanged: function(evt) {
      var currentSlide = parseInt(this.photoSwipeInstance.getCurrentIndex()) + 1;
      $('.pswp__counter--current').text(currentSlide);
    },


    destroyPhotoSwipe: function(evt) {
      $('body').off('pswpTap');
      this.photoSwipeInstance = null;
    },


    onSelect: function() {
      theme.Collapsibles.init();
    }

  });

  return Product;

})();










/*==============================================================================
  #CollectionSection
==============================================================================*/

theme.CollectionSection = (function() {

  var selectors = {};

  var config = {};

  function CollectionSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    // Flag used for filtering and sorting to ensure one action at a time
    var isLoading = this.isLoading = false;

    var newUrl = this.newUrl = '';

    // Initialise section
    this.init();
  }


  CollectionSection.prototype = $.extend({}, CollectionSection.prototype, {

    init: function() {
      this.attachListeners();

      // Filter variables and config
      var tags = this.tags = $('.filter-group__tag');
      var clearFilters = this.clearFilters = $('.js-clear-filters');
      var activeTag = this.activeTag = 'filter-group__item--active';
      var disabledTag = this.disabledTag = 'filter-group__item--disabled';

      // Toggle variables and config
      var $collectionToolbar = this.$collectionToolbar = $('.collection-toolbar');
      var openFiltersClass = this.openFiltersClass = 'collection-toolbar--filters-is-open';
      var $mainFilters = this.$mainFilters = $('.collection-toolbar__main-filters');
      var $mobileFilters = this.$mobileFilters = $('.collection-toolbar-mobile__main-filters');

      var openSortClass = this.openSortClass = 'collection-toolbar--sort-is-open';
      var $mainSort = this.$mainSort = $('.collection-toolbar__main-sort');
      var $mobileSort = this.$mobileSort = $('.collection-toolbar-mobile__main-sort');
    },


    attachListeners: function() {

      var self = this;

      // Filters and Sort button handlers
      $('.js-filters-btn').on('click', this.toggleFilters.bind(this));
      $('.js-sort-btn').on('click', this.toggleSort.bind(this));


      // URL change handler
      $(window).on('popstate', function(state) {
        if (state) {
          self.reloadContent(location.href);
        }
      });

      // Tag filter and sort handlers
      $('.js-filter-tag').on('click', this.filterCollection.bind(this));
      $('.js-clear-filters').on('click', this.filterCollection.bind(this));
      $('.js-sort-link').on('click', this.filterCollection.bind(this));
    },


    filterCollection: function(evt) {

      var self = this;

      // Prevent default link behaviour
      evt.preventDefault();

      var $el = $(evt.currentTarget);
      var $parent = $el.parent();
      var newUrl = $el.attr('href');

      /**
       * If we are loading a previous action, prevent any further actions.
       * Also, prevent clicks on disabled filter tags.
       */
      if (self.isLoading || $parent.hasClass(self.disabledTag)) {
        return;
      }

      // Set loading flag to true
      self.isLoading = true;

      self.prepareReload(newUrl);
    },


    prepareReload: function(newUrl) {
      var self = this;

      /**
       * Add newUrl to history using pushState
       */
      history.pushState({}, '', newUrl);

      /**
       * Add a CSS class to hook into transitions or animations when loading
       * new content
       */
      $('.js-collection-toolbar, .js-collection-content').addClass('collection-reload');

      // Reload content
      self.reloadContent(newUrl);
    },


    reloadContent: function(url) {

      var self = this;

      /**
       * Use the Shopify Sections API to grab content from a section
       * for improved performance. We build a section URL for our
       * AJAX request. Much better than loading an entire page.
       *
       * https://help.shopify.com/en/themes/development/sections/section-rendering-api
       */
      var sectionUrl;


      /**
       * Check if url has a query string e.g. ?sort_by.
       * 1. If we have a query string, we add section_id to the end
       * 2. If no query string, we add section_id with a query string
       */

      if (url.indexOf('?') != -1) {
        sectionUrl = url + '&section_id=' + self.sectionId; /* [1] */
      } else {
        sectionUrl = url + '?sectionId=' + self.sectionId; /* [2] */ 
      }


      /**
       * AJAX function to get new collection content
       */
      $.ajax(sectionUrl, {
        method: 'GET',
        dataType: 'html'
      })
      .done(function(data, textStatus, jqXHR) {
        var tempElement = document.createElement('div');
        tempElement.innerHTML = data;

        document.querySelector('.js-collection-toolbar').innerHTML = tempElement.querySelector('.js-collection-toolbar').innerHTML;

        document.querySelector('.js-collection-content').innerHTML = tempElement.querySelector('.js-collection-content').innerHTML;
      })
      .fail(function() {
        console.log("Filter error");
      })
      .always(function() {

        // Set loading flag to false
        self.isLoading = false;

        // Remove unload class
        $('.js-collection-toolbar, .js-collection-content').removeClass('collection-reload');

        // Reinit Shopify Section
        theme.reinitSection('collection-template-section');

        // Reinit all relevant JS
        self.init();
        theme.Collapsibles.init();

        // #SWYM WISHLIST
        self.reinitWishlist();

      });
    },

    // #SWYM WISHLIST
    reinitWishlist() {
      if(window._swat){
        window._swat.initializeActionButtons(".js-collection-wishlist");
      } else {
        window.SwymCallbacks = window.SwymCallbacks || [];
        window.SwymCallbacks.push(function(){
          window._swat.initializeActionButtons(".js-collection-wishlist");
        });
      }
    },


    toggleFilters: function() {
      var self = this;

      if (self.$collectionToolbar.hasClass(self.openFiltersClass)) {
        self.closeFilters();
      } else {
        self.openFilters();
      }
    },


    openFilters: function() {
      var self = this;

      var filtersHeight = self.$mainFilters.prop('scrollHeight');
      var mobileFiltersHeight = self.$mobileFilters.prop('scrollHeight');

      self.$mainFilters.css('height', filtersHeight + 'px');
      self.$mobileFilters.css('height', mobileFiltersHeight + 'px');

      var transitionEnded = function transitionEnded(evt) {
        if (evt.originalEvent.propertyName === 'height') {
          self.$mainFilters.css('height', 'auto');
          self.$mobileFilters.css('height', 'auto');

          self.$mainFilters.off('transitionend');
          self.$mobileFilters.off('transitionend');
        }
      }

      self.$mainFilters.on('transitionend', transitionEnded);
      self.$mobileFilters.on('transitionend', transitionEnded);


      self.$collectionToolbar.addClass(self.openFiltersClass);
    },


    closeFilters: function() {
      var self = this;

      var filtersHeight = self.$mainFilters.prop('scrollHeight');
      var mobileFiltersHeight = self.$mobileFilters.prop('scrollHeight');

      self.$mainFilters.css('height', filtersHeight + 'px');
      self.$mobileFilters.css('height', mobileFiltersHeight + 'px');

      setTimeout(function() {
        self.$mainFilters.css('height', '0');
        self.$mobileFilters.css('height', '0');
      }, 0);

      self.$collectionToolbar.removeClass(self.openFiltersClass);
    },


    toggleSort: function() {
      var self = this;

      if (self.$collectionToolbar.hasClass(self.openSortClass)) {
        this.closeSort();
      } else {
        this.openSort();
      }
    },


    openSort: function() {
      var self = this;

      var sortHeight = self.$mainSort.prop('scrollHeight');
      var mobileSortHeight = self.$mobileSort.prop('scrollHeight');

      self.$mainSort.css('height', sortHeight + 'px');
      self.$mobileSort.css('height', mobileSortHeight + 'px');

      var transitionEnded = function transitionEnded(evt) {
        if (evt.originalEvent.propertyName === 'height') {
          self.$mainSort.css('height', 'auto');
          self.$mobileSort.css('height', 'auto');

          self.$mainSort.off('transitionend');
          self.$mobileSort.off('transitionend');
        }
      }

      self.$mainSort.on('transitionend', transitionEnded);
      self.$mobileSort.on('transitionend', transitionEnded);


      self.$collectionToolbar.addClass(self.openSortClass);
    },


    closeSort: function() {
      var self = this;

      var sortHeight = self.$mainSort.prop('scrollHeight');
      var mobileSortHeight = self.$mobileSort.prop('scrollHeight');

      self.$mainSort.css('height', sortHeight + 'px');
      self.$mobileSort.css('height', mobileSortHeight + 'px');

      setTimeout(function() {
        self.$mainSort.css('height', '0');
        self.$mobileSort.css('height', '0');
      }, 0);

      self.$collectionToolbar.removeClass(self.openSortClass);
    },

  });

  return CollectionSection;

})();










/*==============================================================================
  #SearchSection
==============================================================================*/

theme.SearchSection = (function() {

  var selectors = {};

  var config = {};

  function SearchSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    // var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    // Initialise section
    this.newSearch();
  }


  SearchSection.prototype = $.extend({}, SearchSection.prototype, {

    init: function() {
    },


    newSearch: function() {
      /**
       * Function to handle starting a new search on the Search page.
       * Separate event handlers for desktop and mobile. Desktop search opens
       * in a header dropdown while mobile search opens in menu drawer.
       */

      /**
       * On desktop
       * 1. Stop propagation to ensure click event doesn't initialise
       *    closeDropdown click event.
       * 2. Cache header search item
       * 3. Pass header search item to openDropdown function 
       */
      $('.js-new-search-desktop').on('click', function(evt) {
        evt.stopPropagation(); /* [1] */
        var $searchDropdown = $('.header-nav__item--search'); /* [2] */
        theme.HeaderNav.openDropdown($searchDropdown); /* [3] */
      });


      /**
       * On mobile
       * 1. Open nav drawer
       * 2. setTimeout function required to add focus
       * 3. Add focus to search input
       * 4. UNUSED as we've opted for CSS only solution. Run focusSearch()
       *    function to show recommended searches.
       */
      $('.js-new-search-mobile').on('click', function(evt) {
        theme.NavDrawer.open(); /* [1] */

        setTimeout(function (){ /* [2] */
          $('.drawer-search__input').focus(); /* [3] */
          // theme.DrawerSearch.focusSearch(); /* [4] */
        }, 500);
        
      });
    }
  });

  return SearchSection;

})();










/*==============================================================================
  #LookbooksSection
==============================================================================*/

theme.LookbooksSection = (function() {

  function LookbooksSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    $('.js-open-lookbook').on('click', function(evt) {
      evt.preventDefault();

      var url = $(this).attr('data-lookbook-url');
      url += '?view=lookbook-view';

      var currentUrl = $('#LookbookModal').attr('data-current-lookbook-url');

      if (url != currentUrl) {
        $('.modal__body').html('');
        
        $.ajax(url, {
          method: 'GET',
          dataType: 'html',
        })
        .done(function(data, textStatus, jqXHR) {
          $('#LookbookModal .modal__body').html(data);
        }).fail(function() {
          console.log('error');
        })
        .always(function() {
        });

        $('#LookbookModal').attr('data-current-lookbook-url', url);
      }
    });
  }


  LookbooksSection.prototype = $.extend({}, LookbooksSection.prototype, {
    onUnload: function() {
    }

  });

  return LookbooksSection;
})();










/*==============================================================================
  #PressSection
==============================================================================*/

theme.PressSection = (function() {

  function PressSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    $('.js-open-press').on('click', function(evt) {
      evt.preventDefault();

      var url = $(this).attr('data-press-url');
      url += '?view=press-view';

      var currentUrl = $('#PressModal').attr('data-current-press-url');

      if (url != currentUrl) {
        $('.modal__body').html('');

        $.ajax(url, {
          method: 'GET',
          dataType: 'html',
        })
        .done(function(data, textStatus, jqXHR) {
          $('#PressModal .modal__body').html(data);
        }).fail(function() {
          console.log('error');
        })
        .always(function() {
        });

        $('#PressModal').attr('data-current-press-url', url);
      }
    });
  }


  PressSection.prototype = $.extend({}, PressSection.prototype, {
    onUnload: function() {
    }

  });

  return PressSection;
})();










/*==============================================================================
  #Stockists Section
==============================================================================*/

theme.StockistsSection = (function() {

  function StockistsSection(container) {
    this.init();
  }

  StockistsSection.prototype = $.extend({}, StockistsSection.prototype, {

    init: function() {
      $('.js-select-stockists').on('change', function(evt) {
        var $this = $(this);

        var value = $this.val();

        $('.stockists-block').removeClass('stockists-block--is-visible');

        $('[data-stockists-group=' + value +']').addClass('stockists-block--is-visible');

        $('.js-select-stockists').val(value);

      });
    },

    /**
     * Shopify Theme Editor events
     */
    onSelect: function() {
    },

    onDeselect: function() {
      
    },

    onUnload: function() {
    }
  });

  return StockistsSection;
})();




















/*==============================================================================
  #TEMPLATES
==============================================================================*/

/*==============================================================================
  #Customer Addresses
  - Largely based off Slate
  - Handles customer addresses functionality
==============================================================================*/

theme.customerAddresses = (function() {

  var $addressForms = $('.js-address-form');

  // If no address forms exist, we don't run the code
  if (!$addressForms.length) {
    return;
  }

  // Certain countries require province selection such as Spain, Canada, UAE
  // We use Shopify.CountryProvinceSelector to show/hide the province selector
  if (Shopify) {
    $('.js-address-country').each(function() {
      var $container = $(this);
      var countryId = $container.data('country-id');
      var provinceId = $container.data('province-id');
      var provinceContainerId = $container.data('province-container-id');

      new Shopify.CountryProvinceSelector(
        countryId,
        provinceId,
        {
          hideElement: provinceContainerId
        }
      );
    });
  }

  // Delete address event handler
  $('.js-address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();










/*==============================================================================
  #Customer Login
  - Largely based off Slate
  - Handles login / recover password form
==============================================================================*/

theme.customerLogin = (function() {

  var config = {
    recoverPasswordToggle: '.js-toggle-recover-form',
    recoverPasswordForm: '#RecoverPasswordForm'
  };

  // Check recover password form exist
  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordToggle).on('click', onShowHidePasswordForm);
  // $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();




















/*==============================================================================
  #INIT
==============================================================================*/

theme.init = function() {
  /**
   * Tab Handling
   * We use CSS to remove focus outlines on a lot of elements for aesthetic
   * reasons.
   * In order to maintain accessibility, we can recognise if a user is tabbing
   * and add an `is-tabbing` class which will allow us to add focus outlines in 
   * the CSS.
   */

  $(document.documentElement).on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      $(document.documentElement).addClass('is-tabbing');
      $(document.documentElement).off('keyup.tab');
    }
  });

  theme.CustomSelect();
  theme.RegionSelect();
  theme.CustomSwitcher();
  // theme.DrawerSearch.init();
  theme.Cart.init();
  theme.Modals.init();
  theme.Collapsibles.init();
  theme.Tabs.init();
  theme.ajaxNewsletterForm();
};




















/*==============================================================================
  #DOC READY
==============================================================================*/

$(document).ready(function() {
  theme.init();

  var sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('drawer-nav-section', theme.DrawerNavSection);
  sections.register('popup-section', theme.PopupSection);
  sections.register('cookies-section', theme.CookiesSection);
  sections.register('product-template-section', theme.Product);
  sections.register('collection-template-section', theme.CollectionSection);
  sections.register('search-template-section', theme.SearchSection);
  sections.register('lookbooks-section', theme.LookbooksSection);
  sections.register('blog-press-section', theme.PressSection);
  sections.register('stockists-section', theme.StockistsSection);

  /**
   * Utility to reinitialise a section
   */
  theme.reinitSection = function(section) {
    for (var i = 0; i < sections.instances.length; i++) {
      var instance = sections.instances[i];
      if (instance['type'] === section) {
        if (typeof instance.forceReload === 'function') {
          instance.forceReload();
        }
      }
    }
  }



  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });


  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'table-wrapper-overflow',
  });


  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

});
